import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';

export default function InfraestruturaBasica() {
  const { watch } = useFormContext();
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a infraestrutura básica do município, incluindo saneamento, energia e iluminação pública.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          name="agua_abastecimento"
          label="Abastecimento de água (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem da população com acesso à rede de abastecimento de água"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="esgoto_cobertura"
          label="Esgotamento sanitário (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem da população com acesso à rede de esgotamento sanitário"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="residuos_coleta"
          label="Coleta de resíduos sólidos (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem da população atendida por coleta de resíduos sólidos"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="energia_cobertura"
          label="Taxa de cobertura de energia elétrica (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem da população com acesso à rede de energia elétrica"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>
      
      <div className="mt-4">
        <FormField
          name="energia_qualidade"
          label="Qualidade do fornecimento (DEC/FEC)"
          placeholder="Digite os índices DEC/FEC"
          helpText="Índices de Duração e Frequência de Interrupção por Unidade Consumidora"
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="iluminacao_cobertura"
          label="Cobertura urbana de iluminação pública (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem da área urbana com iluminação pública"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="iluminacao_sustentavel"
          label="Uso de tecnologias sustentáveis na iluminação"
          type="radio"
          options={[
            { value: 'sim', label: 'Sim' },
            { value: 'nao', label: 'Não' },
          ]}
          helpText="Indique se o município utiliza tecnologias sustentáveis na iluminação pública (LED, energia solar, etc.)"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao5"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao5"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
